// extracted by mini-css-extract-plugin
export var diff = "styles-module__diff___uab6o";
export var easy = "styles-module__easy___z317z";
export var hard = "styles-module__hard___A8wBb";
export var missing = "styles-module__missing___IcVS9";
export var moderate = "styles-module__moderate____rxpe";
export var selected = "styles-module__selected___KQT0h";